import { createContext } from 'react';

/** Lets a section keep its save state while using the page's action bar. */
export const SectionSaveTarget = createContext<HTMLDivElement | null>(null);
